export enum TypeChangementEnum {
  COORDONNEES = 'COORDONNEES',
  COURRIEL = 'COURRIEL',
  TELEPHONE = 'TELEPHONE',
}
export default TypeChangementEnum;
